import { render, staticRenderFns } from "./configuration-local-assays-protocols-modal-assays-form.vue?vue&type=template&id=088643a9&scoped=true&"
import script from "./configuration-local-assays-protocols-modal-assays-form.ts?vue&type=script&lang=ts&"
export * from "./configuration-local-assays-protocols-modal-assays-form.ts?vue&type=script&lang=ts&"
import style0 from "./configuration-local-assays-protocols-modal-assays-form.scss?vue&type=style&index=0&id=088643a9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "088643a9",
  null
  
)

export default component.exports